import CryptoJS from "crypto-js";

export let secretKey =
  `${process.env.SECRET_KEY_CRYPTO_DATA}` || "default-fallback-key";
const BaseKey = "PEPEELA@";

// Função para criptografar
export function encryptData(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
}

// Função para descriptografar
export function decryptData(encryptedData) {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

export function setItemEncryp(key, data) {
  localStorage.setItem(`${BaseKey}${key}`, encryptData(data));
}

export function localStorageRemoveItem(key) {
  localStorage.removeItem(`${BaseKey}${key}`);
}

export function getItemDecrypt(key) {
  const data = localStorage.getItem(`${BaseKey}${key}`);
  if (data) {
    return decryptData(data);
  }
  return null;
}
